import CryptoJS from 'crypto-js';
import { vNetUpdateTagValue } from '../../../../../../redux/slices/vNetSlice';

export const buildSign = (params) => {
    const signString =
        Object.keys(params)
            .sort()
            .map(k => `${k}=${params[k]}`)
            .join("&") + "&key=5cee621329f24e5cbdc43daa959ce9a1";

    return CryptoJS.MD5(signString).toString();
};

export const updateTagByName = async ({
    tagName,
    value,
    dispatch,
    sid,
    tagMap,
    setIsChannelUpdateModal,
    currentDevice,
    setTableData
}) => {
    const tag = tagMap[tagName];

    if (!tag) {
        console.error("Tag not found in map:", tagName);
        return;
    }

    const { boxId, monitorId, devtype } = tag;
    const cuid = "854234a5028f46628cfbc5e135c2b23b";

    const ts = Date.now();
    const sign = buildSign({
        boxId: boxId.toString(),
        monitorId: monitorId.toString(),
        value: value.toString(),
        devtype,
        cuid,
        sid,
        ts: ts.toString(),
        mt: "255",
        pid: "1",
        sv: "1.0",
        lan: "zh",
    });

    const res = await dispatch(
        vNetUpdateTagValue({
            boxId,
            monitorId,
            value,
            devtype,
            cuid,
            ts,
            sign,
            sid,
        })
    ).unwrap();

    if (res?.code === 200) {
        console.log("Updated:", tagName);

        setTableData((prevData) => {
            return prevData.map(row => {
                if (row.Header === tagName) {
                    return { ...row, val: value };
                }
                return row;
            });
        });


    } else {
        console.error(" Failed:", res);
    }

    setIsChannelUpdateModal(false);
};